import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReferToFrndRoutingModule } from './refer-to-frnd-routing.module';
import { ReferenceComponent } from './reference/reference.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


@NgModule({
  declarations: [
    ReferenceComponent
  ],
  imports: [
    CommonModule,
    ReferToFrndRoutingModule,
    NgxDatatableModule
  ]
})
export class ReferToFrndModule { }
